module.exports = __webpack_public_path__ + "img/workspace-onboarding/add-to-team-library-3b75257dfc8f9a615c14bbf88705625b.png";